import React from 'react';
import { IconProps } from '../../types/icon';

const TrendArrowIcon: React.FC<IconProps> = ({ className, size = 49 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 49 48" fill="none" className={className}>
      <g clipPath="url(#clip0_1_1910)">
        <path d="M42.9165 12H30.9165C29.8105 12 28.9165 12.894 28.9165 14C28.9165 15.106 29.8105 16 30.9165 16H42.0885L28.9645 29.124C27.8365 30.252 26.0005 30.252 24.8705 29.124L19.7925 24.046C17.1045 21.358 12.7305 21.358 10.0425 24.046L1.50252 32.586C0.720516 33.368 0.720516 34.632 1.50252 35.414C1.89252 35.804 2.40452 36 2.91652 36C3.42852 36 3.94052 35.804 4.33052 35.414L12.8705 26.874C13.9645 25.78 15.8705 25.78 16.9645 26.874L22.0425 31.952C24.7305 34.64 29.1045 34.64 31.7925 31.952L44.9185 18.828V30C44.9185 31.106 45.8125 32 46.9185 32C48.0245 32 48.9185 31.106 48.9185 30V18C48.9185 14.692 46.2245 12 42.9165 12Z" fill="url(#paint0_linear_1_1910)"/>
      </g>
      <defs>
        <linearGradient id="paint0_linear_1_1910" x1="0.916015" y1="24" x2="48.9185" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00D650"/>
          <stop offset="1" stopColor="#0081FE"/>
        </linearGradient>
        <clipPath id="clip0_1_1910">
          <rect width="48" height="48" fill="white" transform="translate(0.916504)"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default TrendArrowIcon;